export class FileType {
    id: number;
    name: string;
    nameEnglish: string;
    menuId: number;
    required: boolean;
}
